import React, { ReactElement } from "react";
import Button from "@components/Button/Button";
import "./Modal.scss";
import ReactDom from "react-dom";
import { toast } from "react-toastify";
import _ from "lodash";
interface ModalProps {
    open: boolean;
    onClose: () => void;
    saveVariables: () => void;
    varNames: string[];
}

export function Modal({ open, onClose, saveVariables, varNames }: ModalProps) {
    if (!open) return null;
    var varElements = (varNames: Array<string>) => {
        if (!varNames || varNames.length == 0) {
            toast.warn("This document doesn't contain deal specific data.");
            onClose();
            return;
        }

        var rows = new Array<ReactElement>();
        for (let name of varNames) {
            var element_class = `VARIABLE_${name}`;

            try {
                var currentValue =
                    document.getElementsByClassName(element_class)[0]
                        .textContent;
            } catch (e) {
                // toast.error(
                //     `Variable ${name} has been removed from the document.`
                // ); //this should work but there is something w the regex that needs fixing
                continue;
            }

            rows.push(
                <tr key={name}>
                    <td>{_.startCase(name)}:</td>
                    <td>
                        <input
                            id={name + "_NEW_VALUE"}
                            type="text"
                            defaultValue={currentValue}
                        />
                    </td>
                </tr>
            );
        }
        return rows;
    };

    return ReactDom.createPortal(
        <>
            <div
                className="background"
                onClick={() => {
                    onClose();
                    toast.warn("No changes were made.");
                }}
            ></div>

            <div className="modal">
                <h2>Edit Incoming Data</h2>
                <div className="content">
                    <table className="variables">
                        <tbody>{varElements(varNames)}</tbody>
                        </table>
                </div>

                <div className="actions">
                    <Button
                        buttonStyle="btn--secondary"
                        onClick={() => {
                            onClose();
                            toast.warn("No changes were made.");
                        }}
                    >
                        Discard
                    </Button>
                    <Button
                        buttonStyle="btn--primary"
                        onClick={() => {
                            saveVariables();
                            onClose();
                            toast.success("Variables updated.");
                        }}
                    >
                        Save
                    </Button>
                </div>
            </div>
        </>,
        document.body
    );
}
